// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

// Scrolls a sidebar row into view WITHIN ITS PANE ONLY. Scrolling is opt-in:
// file sidebars mark their scroll containers with FILE_SCROLL_PANE_ATTR and
// only the nearest marked ancestor that actually overflows moves, so unmarked
// containers - above all a page scroller under the map - never chase a row.
export const FILE_SCROLL_PANE_ATTR = 'data-file-scroll-pane';

export const scrollRowIntoPane = (row: HTMLElement): void => {
  let pane = row.parentElement;
  while (pane) {
    if (pane.hasAttribute(FILE_SCROLL_PANE_ATTR) && pane.scrollHeight > pane.clientHeight) break;
    pane = pane.parentElement;
  }
  if (!pane) return;
  const paneRect = pane.getBoundingClientRect();
  const rowRect = row.getBoundingClientRect();
  if (rowRect.top < paneRect.top) {
    pane.scrollTop += rowRect.top - paneRect.top;
  } else if (rowRect.bottom > paneRect.bottom) {
    pane.scrollTop += rowRect.bottom - paneRect.bottom;
  }
};

export default scrollRowIntoPane;
